<script lang="ts" module>
  import { tv } from 'tailwind-variants';

  import { BaseBtn, Icon, type BaseBtnProps, type IconName } from '@/ui/base';

  export interface Props {
    variant?: 'cta' | 'primary' | 'secondary';
    icon?: IconName;
    loading?: boolean;
  }

  export type CTAButtonProps = Props & BaseBtnProps;

  const styles = tv({
    base: 'fr-cc gap-2 rounded-sm px-4 py-2 !text-label-sm',
    variants: {
      variant: {
        cta: 'bg-btn-cta hocus:bg-btn-cta-H',
        primary: 'bg-btn-prim  hocus:bg-btn-prim-H',
        secondary: 'bg-btn-sec hocus:bg-btn-sec-H',
      },
      disabled: {
        true: 'bg-btn-disabled text-c-disabled hocus:bg-btn-disabled',
      },
    },
    compoundVariants: [
      {
        disabled: false,
        variant: ['cta', 'primary'],
        class: 'text-c-inverted',
      },
    ],
  });
</script>

<script lang="ts">
  let {
    variant = 'cta',
    disabled = false,
    class: className,
    children,
    loading = false,
    icon,
    ...props
  }: CTAButtonProps & { tooltip?: string } = $props();

  let iconName = $derived(loading ? 'Loading' : icon);

  let cn = $derived(styles({ variant, disabled: !!disabled, className }));
</script>

<BaseBtn {...props} disabled={!!disabled || loading} class={cn}>
  {#if loading}
    <Icon icon="Loading" size={4} />
  {:else}
    {@render children?.()}
    {#if iconName}
      <Icon icon={iconName} size={4} />
    {/if}
  {/if}</BaseBtn
>
